import { CommandDisplayOption } from "powerbi-models";
import * as pbi from "powerbi-client";
const CMD_SHOW = "show";
const CMD_HIDE = "hide";
export const LANG_UNDEFINED = "und";
export const getLanguagePrefix = (appUrl) => {
    let langcode = document.URL.split("/reports/")[0].split("/")[3];
    if (langcode) {
        return langcode.replace("/", "");
    }
    return LANG_UNDEFINED;
};
export const getUserLanguage = () => {
    const docLang = document.documentElement.lang;
    if (docLang && String(docLang).length > 0) {
        return docLang;
    }
    const navLangFull = navigator.language;
    if (navLangFull && String(navLangFull).length > 0) {
        const navLang = String(navLangFull).split("-")[0];
        if (navLang && String(navLang).length > 0) {
            return navLang;
        }
    }
    return "en";
};
export const createEmbedConfig = (reportConfig, isTabVisible, lang) => {
    let commands = [
        {
            drill: {
                displayOption: CommandDisplayOption.Hidden,
            },
        },
    ];
    let embedConfiguration = {
        type: "report",
        accessToken: reportConfig.accessToken,
        embedUrl: "https://app.powerbi.com/reportEmbed?groupId=" + reportConfig.workspaceId,
        id: reportConfig.reportId,
        tokenType: pbi.models.TokenType.Embed,
        settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: isTabVisible,
            commands: commands,
            localeSettings: {
                language: lang,
                formatLocale: lang,
            },
        },
    };
    return embedConfiguration;
};
export const getReportNameFromURL = (appUrl) => {
    let splitUrl = appUrl.split("?")[0];
    let splittedPath = splitUrl.split("/");
    let reportName = splittedPath[splittedPath.length - 1];
    return reportName;
};
export const applyBookmark = (pageName, action, bookmarks) => {
    let bookmark = findBookmark(pageName, action, bookmarks);
    if (bookmark) {
        window.report.bookmarksManager.apply(bookmark.name);
    }
    else {
        console.error("Bookmark for page '" + pageName + "' and action '" + action + "' not found.");
    }
};
export const findBookmark = (pageName, action, bookmarks) => {
    if (bookmarks) {
        let filterdBookmarks = bookmarks.filter((bookmark) => bookmark.displayName == action + " " + pageName);
        if (filterdBookmarks.length == 1) {
            return filterdBookmarks[0];
        }
    }
    return null;
};
export const bookmarksExists = (pageName, bookmarks) => findBookmark(pageName, CMD_SHOW, bookmarks) && findBookmark(pageName, CMD_HIDE, bookmarks);
